var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.label,"items":_vm.choices,"multiple":_vm.multiple,"value":_vm.value,"clearable":_vm.clearable,"outlined":_vm.outlined,"dense":_vm.dense,"hide-details":_vm.hide_details},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }